export default async (response, catchCallback = null) => {
  const isOk = response.ok;
  let data;
  try {
    // try to get error data from response
    data = await response.json();
    // legacy code looks to use 'message', if there is no message then map from errorCode
    if (data.errorCode && !data.message) {
      data.message = data.errorMessage || `API Error - Code: ${data.errorCode}`;
    }
  } catch (error) {
    data = {
      message: `API Error - Code: ${response.status}`,
      errorCode: response?.status,
      errorStatus: response?.statusText,
      url: response?.url,
      errorStack: error?.stack,
      type: response?.type,
    };
    if (catchCallback && typeof catchCallback === 'function') {
      catchCallback(data);
    }
  }

  // property throw error if there is no response error data
  if (!data && !isOk) {
    const errorMessage = `Fetch Error - status:${response?.status} statusText: ${response?.statusText} url:${response?.url}`;

    if (catchCallback && typeof catchCallback === 'function') {
      const data = {
        message: errorMessage,
        errorCode: response?.status,
        errorStatus: response?.statusText,
        url: response?.url,
        errorStack: error?.stack,
      };
      catchCallback(data);
      return;
    }
    throw new Error(errorMessage);
  }

  return data;
};
